import { TransactionData, TransactionStatus } from '@/features/Transactions/transactions.types'
import { CardReverse } from '@/features/Transactions/ui/MobileTxRow/Types/CardReverse'
import { CardSpend } from '@/features/Transactions/ui/MobileTxRow/Types/CardSpend'
import { CardTariffPayment } from '@/features/Transactions/ui/MobileTxRow/Types/CardTariffPayment'
import { ChangeBalance } from '@/features/Transactions/ui/MobileTxRow/Types/ChangeBalance'
import { Delegate } from '@/features/Transactions/ui/MobileTxRow/Types/Delegate'
import { RevokeDelegate } from '@/features/Transactions/ui/MobileTxRow/Types/RevokeDelegate'
import { AppRoutes } from '@/routes'
import { getUrl } from '@/shared/helpers/url'
import { useRouter } from 'nextjs-toploader/app'
import React, { ComponentType, useCallback } from 'react'

type TransactionComponentProps = {
  onClick: () => void;
  transaction: TransactionData;
  withoutDate: boolean;
}

const transactionComponentMap: Record<string, ComponentType<TransactionComponentProps>> = {
  APPROVE_DELEGATE: Delegate,
  CARD_SPEND: CardSpend,
  CARD_REVERSE: CardReverse,
  REVOKE_DELEGATE: RevokeDelegate,
  CHANGE_BALANCE: ChangeBalance,
  PAYMENT: CardTariffPayment,
}

function resolveComponentKey(transaction: TransactionData) {
  if (transaction.data.type !== 'CARD_TRANSACTION') return transaction.data.type

  const { cardTransactionType } = transaction.data

  return cardTransactionType === 'REVERSE' || cardTransactionType === 'REFUND' ? 'CARD_REVERSE' : 'CARD_SPEND'
}

export function MobileTxRow({ transaction, withoutDate = false }: {
  transaction: TransactionData;
  withoutDate?: boolean;
}) {
  const router = useRouter()

  const handleClick = useCallback(() => {
    if (transaction.status === TransactionStatus.IN_PROGRESS || transaction.status === TransactionStatus.ERROR_SEND) {
      return
    }
    router.push(getUrl(AppRoutes.TRANSACTION_DETAILS_PAGE, { id: transaction.id }))
  }, [router, transaction])

  if (!transaction) return null

  const TransactionComponent = transactionComponentMap[resolveComponentKey(transaction)]

  return (
    TransactionComponent ? (
      <TransactionComponent onClick={handleClick} transaction={transaction} withoutDate={withoutDate} />
    ) : null
  )
}
